"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CityRoutes = void 0;
var CityRoutes;
(function (CityRoutes) {
    CityRoutes["BasePrefix"] = "cities";
    CityRoutes["ById"] = ":cityId";
    CityRoutes["All"] = "all";
    CityRoutes["List"] = "list";
})(CityRoutes = exports.CityRoutes || (exports.CityRoutes = {}));
